import { Axios } from "utils";

export const getProgramDetails = async (studentBatchId) => {
  const res = await Axios.get(
    `v2/portal/Programs/batches/${studentBatchId}/program-details`
  );
  return res.data;
};
